export const VISIT_INVENTORY_APP = 'visit_inventory_system'
